module.exports = "/_next/static/images/piggyalt-b2bc6310a1abc42a2ceda4fb2b9930d6.svg";